import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_BASH_URL;
const API_URL = `${BaseUrl}/admin/blogs`;

// Async Thunks
export const fetchBlogs = createAsyncThunk('blogs/fetchBlogs', async ({ page = 1, limit = 10, category = '', status = '', date = '' }) => {
  const token = localStorage.getItem("admin-auth-token");
  const response = await axios.get(API_URL, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, limit, category, status, date },
  });
  return response.data;
});

export const createBlog = createAsyncThunk('blogs/createBlog', async (blogData) => {
  const token = localStorage.getItem("admin-auth-token");
  const response = await axios.post(API_URL, blogData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.blog;
});

export const updateBlog = createAsyncThunk('blogs/updateBlog', async ({ id, blogData }) => {
  const token = localStorage.getItem("admin-auth-token");
  const response = await axios.put(`${API_URL}/${id}`, blogData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.blog;
});


export const getBlog = createAsyncThunk('blogs/getBlog', async (id) => {
  const token = localStorage.getItem("admin-auth-token");
  const response = await axios.get(`${API_URL}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.blog;
});


export const deleteBlogs = createAsyncThunk('blogs/deleteBlogs', async (ids) => {
  const token = localStorage.getItem("admin-auth-token");
  const response = await axios.delete(API_URL, {
    headers: { Authorization: `Bearer ${token}` },
    data: { ids },
  });
  return ids;
});

// Slice
const blogsSlice = createSlice({
  name: 'blogs',
  initialState: {
    blogs: [],
    currentPage: 1,
    totalPages: 1,
    totalBlogs: 0,
    loading: false,
    error: null,
    selectedBlogs: [],
  },
  reducers: {
    toggleBlogSelection: (state, action) => {
      const blog = state.blogs.find(b => b._id === action.payload);
      if (blog) {
        blog.selected = !blog.selected;
        state.selectedBlogs = blog.selected
          ? [...state.selectedBlogs, action.payload]
          : state.selectedBlogs.filter(id => id !== action.payload);
      }
    },
    toggleAllBlogSelection: (state, action) => {
      state.blogs.forEach(blog => (blog.selected = action.payload));
      state.selectedBlogs = action.payload ? state.blogs.map(blog => blog._id) : [];
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload.blogs.map(blog => ({ ...blog, selected: false }));
        state.currentPage = action.payload.currentPage;
        state.totalPages = action.payload.totalPages;
        state.totalBlogs = action.payload.totalBlogs;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createBlog.fulfilled, (state, action) => {
        state.blogs.unshift({ ...action.payload, selected: false });
        state.totalBlogs += 1;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        console.log(action.payload)
        state.blogs = state.blogs.map(blog =>
          blog._id === action.payload._id ? { ...action.payload, selected: false } : blog
        );
      })
      .addCase(deleteBlogs.fulfilled, (state, action) => {
        state.blogs = state.blogs.filter(blog => !action.payload.includes(blog._id));
        state.selectedBlogs = [];
        state.totalBlogs -= action.payload.length;
      });
  },
});

export const { toggleBlogSelection, toggleAllBlogSelection, setPage } = blogsSlice.actions;
export default blogsSlice.reducer;